import { SET_SEARCH_INFO, SearchState } from './constant';

interface SearchAction {
  type: string;
  payload: SearchState;
}

const INIT_STATE: SearchState = {
  value: '',
};

export default (state: SearchState = INIT_STATE, action: SearchAction) => {
  const { type, payload } = action;
  switch (type) {
    case SET_SEARCH_INFO:
      return {
        ...state,
        value: payload.value,
      };
    default:
      return state;
  }
};
